import { useTranslation } from "react-i18next"
import { Pearl, PearlProvider } from "@oysterhr/pearl"
import { useParams } from "react-router-dom"
import { ErrorPage } from "~/shared/pages/system/ErrorPage"
import ConnectPaymentMethodLayout from "../../../layouts/ConnectPaymentMethodLayout"
import { SepaAdvisor } from "../SepaFlowPage/components/SepaAdvisor"
import { PaymentEngagementType } from "../../../enums"
import { NewSepaFTEFlow } from "./NewSepaFTEFlow"
import { NewSepaContractorFlow } from "./NewSepaContractorFlow"

const NewSepaFlowPage = () => {
  const { paymentFlow } = useParams()
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/SepaFlow")

  if (!paymentFlow) return <ErrorPage errorCode="404" />

  return (
    <PearlProvider>
      <ConnectPaymentMethodLayout title={t("title")} subtitle={t("subtitle")}>
        {paymentFlow === PaymentEngagementType.Fte ? <NewSepaFTEFlow /> : <NewSepaContractorFlow />}
        <div className="text-left">
          <Pearl name="sepa-flow-page">
            <Pearl.SideBox>
              <SepaAdvisor newFlow />
            </Pearl.SideBox>
          </Pearl>
        </div>
      </ConnectPaymentMethodLayout>
    </PearlProvider>
  )
}

export default NewSepaFlowPage
